module.exports = __webpack_public_path__ + "static/img/xuanzhong-bg.9044e41e.png";